import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router';
import { AuthGuard } from 'app/core/auth/rapallo/auth.guard';
import { NoAuthGuard } from 'app/core/auth/rapallo/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { GMapService } from 'app/services/gmap.service';
import { catchError, forkJoin, map, of } from 'rxjs';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';


const isWebResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const httpClient:HttpClient = inject(HttpClient);
    const backendUrls: BackendUrls = inject(BACKEND_URLS)
    return httpClient.get(`${backendUrls.backendApiUrl}/isweb/portal`,{params: {"expJson": "1","expJsonEl":"198,199"}}).pipe(
        catchError((err: Response) => {
            if (err.status === 200) {
                console.log(err['message']);
            }
            return of(null);
        })
    )
}



const initialDataResolver = () => {
    //const messagesService = inject(MessagesService);
    //const notificationsService = inject(NotificationsService);
    //const quickChatService = inject(QuickChatService);
    //const shortcutsService = inject(ShortcutsService);
    const navigationService = inject(NavigationService);
    const mapService = inject(GMapService);
    return forkJoin([
        navigationService.get(),
        // navigationService.getData(),
        //messagesService.getAll(),
        //notificationsService.getAll(),
        //quickChatService.getChats(),
        //shortcutsService.getAll(),
        mapService.loadGoogleMaps('marker,drawing,geometry')
    ]);

}

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'area-utente/scrivania'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'area-utente/scrivania'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'rapallo-orizzontale',
        },
        resolve: {
            initialData: initialDataResolver,
            isweb:isWebResolver
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/split-screen-reversed-rapallo/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
            isweb:isWebResolver,
        },
        children: [
            {path: 'settings', loadChildren: () => import('app/settings/settings.routes')},
            {path: 'area-x', loadChildren: () => import('app/modules/area-utente/area-utente.routes')},


            {path: 'area-utente', loadChildren: () => import('app/modules/area-utente/area-utente.routes')},


            {path: 'area-amministratore', loadChildren: () => import('app/modules/area-amministratore/area-amministratore.routes'),
            // data:{
            //     layout: 'rapallo-verticale'
            // }
            },

            {
                path: 'area-istruttore', loadChildren: () => import('app/modules/area-istruttore/area-istruttore.routes'),
                data: {
                    layout: 'spezia-verticale'
                }
            },

            //Servizi
            {
                path: 'servizi-online',
                data:{
                    breadcrumb: 'Servizi',
                    externalUrl:'https://www.comune.rapallo.ge.it/pagina133691_servizi.html'
                },
                children: [
                    {path: '', redirectTo:'/area-utente/servizi-online', pathMatch:'full'},

                    {
                        path: 'occupazione-suolo', loadChildren: () => import('app/routes/istanze.routes'),
                        data: {
                            breadcrumb: 'Autorizzazioni',
                            externalUrl: 'https://www.comune.rapallo.ge.it/area_letturaServizio/pagsistema.html?type=35'
                        },
                    },
                    {path: 'comunicazioni', loadChildren: () => import('app/routes/istanze.routes'),
                        data:{
                            breadcrumb: 'Comunicazioni'
                        },
                    }
                ]
            }

        ],
        data:{
            layout: 'rapallo-orizzontale',
            breadcrumb: 'Home',
            externalUrl:'https://www.comune.rapallo.ge.it'
        }
    },

    {path: '**', redirectTo: 'area-utente/scrivania'},

];
